import { render, staticRenderFns } from "./StateV2.vue?vue&type=template&id=5c4f43ed&scoped=true&"
import script from "./StateV2.vue?vue&type=script&lang=js&"
export * from "./StateV2.vue?vue&type=script&lang=js&"
import style0 from "./StateV2.vue?vue&type=style&index=0&id=5c4f43ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f43ed",
  null
  
)

export default component.exports